import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "lucide-react";
import type { LegalDoc } from "../data/legal";
type LegalModalProps = {
  doc: LegalDoc | null;
  onClose: () => void;
};
export function LegalModal({
  doc,
  onClose
}: LegalModalProps) {
  useEffect(() => {
    if (!doc) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [doc, onClose]);
  return <AnimatePresence data-id="element-73" data-mp="1ec8d7hj75u0">
      {doc && <motion.div className="fixed inset-0 z-[70] flex items-center justify-center bg-cocoa-dark/60 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onClick={onClose} data-id="element-74" data-mp="1dapigu9xf1q">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="legal-title" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.98,
        y: 8
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={e => e.stopPropagation()} className="flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl bg-cream text-cocoa shadow-2xl" data-id="element-75" data-mp="1aq6nls717ijk">
            <header className="flex items-center justify-between border-b border-blush-dark/50 px-6 py-4" data-id="element-76" data-mp="11xlb2ttzu836">
              <h2 id="legal-title" className="font-display text-2xl font-bold" data-id="element-77" data-mp="16p3c1hw0o8o5">{doc.title}</h2>
              <button type="button" onClick={onClose} aria-label="Cerrar" autoFocus className="rounded-full p-2 text-cocoa-light transition-colors duration-150 hover:bg-blush-light hover:text-cocoa" data-id="element-78" data-mp="99z91q0ezbif">
                <XIcon className="h-5 w-5" data-id="element-79" data-mp="19b4pjwejzkq" />
              </button>
            </header>
            <div className="space-y-5 overflow-y-auto px-6 py-6 text-sm leading-relaxed" data-id="element-80" data-mp="fxeb2uecxda2">
              {doc.sections.map(s => <section key={s.heading} data-id="element-81" data-mp="azm895c6c6r3">
                  <h3 className="font-bold text-cocoa" data-id="element-82" data-mp="b0xa2zm274fk">{s.heading}</h3>
                  <p className="mt-1 text-cocoa-light" data-id="element-83" data-mp="3jewg6u2qw66s">{s.body}</p>
                </section>)}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}